import React from 'react';
const IconActionMoveToFolderFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 4H12.47L11.21 2.5H2V20H22V4ZM14.95 16H12.34L14.86 13H6V11H14.85L12.33 8H14.94L18.3 12L14.95 16Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionMoveToFolderFill;